import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { ImageBackground, useWindowDimensions } from 'react-native';
import { LocalAssets } from 'screens/AssetsScreen/LocalAssets/LocalAssets';
import { NoLocalAssets } from 'screens/AssetsScreen/LocalAssets/NoLocalAssets';
import { selectAssetsTotal } from 'store/assets/selectors';

const AssetBackdropJpeg = require('assets/backdrop.jpg');

export const AssetsScreen: React.FC = () => {
  const totalAssets = useSelector(selectAssetsTotal);
  const { height } = useWindowDimensions();
  return totalAssets === 0 ? (
    <>
      <ImageBackground
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height,
          opacity: 0.2,
        }}
        imageStyle={{ resizeMode: 'cover' }}
        source={AssetBackdropJpeg}
      />
      <NoLocalAssets />
    </>
  ) : (
    <LocalAssets />
  );
};
